import React,{useEffect,useState} from 'react';
import Button from 'react-bootstrap/Button';
import * as Yup from 'yup';
import {InputText,Form,SelectField} from '../../components/FormElement'

import { fetchWrapper } from '../helpers';
import { useToast } from '@chakra-ui/react'




function Edit({loadList,user_type_id,handleClose,rs}){
	
	const toast = useToast()

	const backendUrl = process.env.REACT_APP_API_URL

	const [formData, setFormData] = useState({
    first_name: rs.first_name,
    last_name: rs.last_name,
    username: rs.username,
    id:rs.id
   
    
  });

  const FormSchema = Yup.object().shape({
	     first_name: Yup.string()
	          .required('Required'),
	    last_name: Yup.string()
	          .required('Required'),
	    username: Yup.string()
	          .required('Required'),
	   
	   
	     
	});


	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

		   let  data = values
		  
	       
	     const url = `${backendUrl}/user/update`;
  		 await fetchWrapper.post(url,data)
  		 loadList();

  		 toast({
  		 	  position: 'top',
  		 	  variant:'top-accent',
          title: 'Congratulation.',
          description: "Record has been updated.",
          status: 'info',
          duration: 1000,
          isClosable: true,
        })

  		 handleClose();
	}

	


	return (

			<>
			<div className="create_user_form">
				<Form
			            enableReinitialize
			            validationSchema={FormSchema}
			            initialValues={formData}
			            onSubmit={onSubmit}
			 	>


			 	<InputText name="first_name" title="First Name"  />
			 	<InputText name="last_name" title="Last Name"  />
			 	<InputText name="username" title="Email"  />

			 	
			 	


		         <Button
				            mt={4}
				            colorScheme='teal'
				            className="primary"
				            type='submit'
		          		>
		           		 Update
		          		</Button>

			</Form>
			</div>
			</>

	)
}

export default Edit;